import React, {Component, Fragment} from 'react';
import {Checkbox, Row, Col, Input, Button, Tabs, Modal, Form, Table, Divider, Tag } from 'antd';
import {StyledDetailsCard} from './style';
import {StyledSubscriptionCard} from "../user-profile/style";
import AccountModal from "./accountModal";
const FormItem = Form.Item;


const columns = [
  {
    title: 'Account Name',
    dataIndex: 'accountName',
    key: 'accountName',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
  },
  // {
  //   title: 'Portfolio Number',
  //   dataIndex: 'portfolioNumber',
  //   key: 'portfolioNumber',
  // },
  {
    title: 'Brokerage',
    key: 'brokerage',
    dataIndex: 'brokerage',
  },
  {
    title: 'Action',
    key: 'action',
    render: () => (
        <span>
      <a href="javascript:;">Delete</a>
    </span>
    ),
}];

const data = [{
    key: '1',
    startDate: '01/01/2010',
    accountName: "raj",
    portfolioNumber: 5,
    brokerage: 'Think or Swim',
}, {
    key: '2',
    startDate: '02/02/2011',
    accountName: "joy",
    portfolioNumber: 5,
    brokerage: 'Charles Schwab',
}, {
    key: '3',
    startDate: '03/03/2013',
    accountName: "vij",
    portfolioNumber: 8,
    brokerage: 'Think or Swim',
}];

class AccountPage extends Component {

    state: State = {
        visible: false,
        item: ''
    }

    componentWillMount() {

    }

    showAccountModal = (item) => {
        this.setState({
            visible: true,
            item: item
        })
    }

    hideAccountModal = () => {
        this.setState({
            visible: false,
            item: null,
        })
    }

    render() {
        const { visible } = this.state
        return (
            <div>
                <Button onClick={this.showAccountModal}>New</Button>
                <Table columns={columns} dataSource={data} pagination={false} size="small" />
                {<AccountModal visible={visible} hideAccountModal={this.hideAccountModal} />}
            </div>
        )
    }
}

export default AccountPage





// WEBPACK FOOTER //
// ./src/components/setup-and-settings/accountPage.js